import { createDefaultDispatcher34z5li45gie67 as createDefaultDispatcher } from './CoroutineContext.mjs';
import { Unconfined_getInstance1rlyi4osl1590 as Unconfined_getInstance } from './Unconfined.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MainCoroutineDispatcher158x49bd8e9gp as MainCoroutineDispatcher } from './MainCoroutineDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatchersClass;
function Dispatchers() {
  if (DispatchersClass === VOID) {
    class $ {
      constructor() {
        Dispatchers_instance = this;
        this.i13_1 = createDefaultDispatcher();
        this.j13_1 = Unconfined_getInstance();
        this.k13_1 = new (JsMainDispatcher())(this.i13_1, false);
        this.l13_1 = null;
      }
      m13() {
        var tmp0_elvis_lhs = this.l13_1;
        return tmp0_elvis_lhs == null ? this.k13_1 : tmp0_elvis_lhs;
      }
    }
    initMetadataForObject($, 'Dispatchers');
    DispatchersClass = $;
  }
  return DispatchersClass;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new (Dispatchers())();
  return Dispatchers_instance;
}
var JsMainDispatcherClass;
function JsMainDispatcher() {
  if (JsMainDispatcherClass === VOID) {
    class $ extends MainCoroutineDispatcher() {
      constructor(delegate, invokeImmediately) {
        super();
        this.v1l_1 = delegate;
        this.w1l_1 = invokeImmediately;
        this.x1l_1 = this.w1l_1 ? this : new (JsMainDispatcher())(this.v1l_1, true);
      }
      j17() {
        return this.x1l_1;
      }
      x12(context) {
        return !this.w1l_1;
      }
      a13(context, block) {
        return this.v1l_1.a13(context, block);
      }
      toString() {
        var tmp0_elvis_lhs = this.k17();
        return tmp0_elvis_lhs == null ? this.v1l_1.toString() : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'JsMainDispatcher');
    JsMainDispatcherClass = $;
  }
  return JsMainDispatcherClass;
}
//region block: exports
export {
  Dispatchers_getInstance as Dispatchers_getInstance2p2r3ndn98nn,
};
//endregion

//# sourceMappingURL=Dispatchers.mjs.map
